// Fallback deep-links so the user can open our site inside the wallet's in-app browser.
export function buildDeepLink(kind) {
  if (typeof window === 'undefined') return null;
  const host = window.location.host + window.location.pathname;
  const full = window.location.href;
  if (kind === 'trust')       return `https://link.trustwallet.com/open_url?coin_id=20000714&url=${encodeURIComponent(full)}`;
  if (kind === 'metamask')    return `https://metamask.app.link/dapp/${host}`;
  if (kind === 'tokenpocket') return `tpdapp://open?params=${encodeURIComponent(JSON.stringify({ url: full, chain: 'BSC', source: 'ADNFT' }))}`;
  if (kind === 'binance')     return `bnc://app.binance.com/mp/app?appId=xoqXxUSMRccLCratcCGKAG&startPagePath=${encodeURIComponent('pages/browser/index')}&startPageQuery=${encodeURIComponent('url=' + full)}`;
  return null;
}

export function isMobile() {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
}
